import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import * as S from '@/components/Ad/WarningPendingState/WarningPendingState.styles';
import { useServerDataContext } from '@/contexts';

export const WarningPendingState = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;

  if (!adData) return null;

  return (
    <S.Warning>
      <S.WarningTitle $variant="4">
        {t('pages.ad.top_warning_title')}
      </S.WarningTitle>
      <S.WarningDescription $variant="1">
        {t('pages.ad.top_warning_description')}
      </S.WarningDescription>
    </S.Warning>
  );
};
